<template>
  <div class="statistics-main--container no-select">
    <div class="section-title mrg-t-25">Отчет</div>

    <div v-if="isSelectedPeriod" class="statistics-main--report-container">
      <div class="statistics-main--cards mrg-t-10">
        <div class="card">
          <div class="shadow-card">
            <div class="title">Доход</div>
            <div class="value">{{statData.all_income}}</div>
            <div v-if="isSelectedCompare" class="value-compare">
              <span class="compare-title">За период сравнения: </span>
              <span class="compare-val">{{compareStatData.all_income}}</span>
            </div>
            <div class="hint">
              <div>На основе записей в статусе "Выполнена"</div>
              <div>
                Доход за групповые записи считается по формуле: Стоимость Услуги * 
                Кол-во записанных клиентов
              </div>
            </div>
          </div>
        </div>
        <div class="card">
          <div class="shadow-card">
            <div class="title">Средний чек</div>
            <div class="value">{{statData.avg_check}}</div>
            <div v-if="isSelectedCompare" class="value-compare">
              <span class="compare-title">За период сравнения: </span>
              <span class="compare-val">{{compareStatData.avg_check}}</span>
            </div>
            <div class="hint">На основе записей в статусе "Выполнена"</div>
          </div>
        </div>
        <div class="card">
          <div class="shadow-card">
            <div class="title">Заполненность</div>
            <div class="value">{{statData.fullness_percent}} %</div>
            <div v-if="isSelectedCompare" class="value-compare">
              <span class="compare-title">За период сравнения: </span>
              <span class="compare-val">{{compareStatData.fullness_percent}} %</span>
            </div>
            <div class="hint">
              Отображает общий % загруженности сотрудников (Отношение
              отработанных часов по записи к количеству рабочих часов всех сотрудников).
              Учитываются записи в статусе "Выполнена"
            </div>
          </div>
        </div>
      </div>
      <div class="statistics-main--cards">
        <div class="card">
          <div class="shadow-card">
            <div class="title">Всего записей</div>
            <div class="value">{{statData.all_enroll_count}}</div>
            <div v-if="isSelectedCompare" class="value-compare">
              <span class="compare-title">За период сравнения: </span>
              <span class="compare-val">{{compareStatData.all_enroll_count}}</span>
            </div>
            <div class="hint"></div>
          </div>
        </div>
        <div class="card">
          <div class="shadow-card">
            <div class="title">Записей в статусе "Выполнена"</div>
            <div class="value">{{statData.done_enroll_count}}</div>
            <div v-if="isSelectedCompare" class="value-compare">
              <span class="compare-title">За период сравнения: </span>
              <span class="compare-val">{{compareStatData.done_enroll_count}}</span>
            </div>
            <div class="hint"></div>
          </div>
        </div>
        <div class="card">
          <div class="shadow-card">
            <div class="title">Записей в статусе "Отменена"</div>
            <div class="value">{{statData.cancel_enroll_count}}</div>
            <div v-if="isSelectedCompare" class="value-compare">
              <span class="compare-title">За период сравнения: </span>
              <span class="compare-val">{{compareStatData.cancel_enroll_count}}</span>
            </div>
            <div class="hint"></div>
          </div>
        </div>
      </div>
      <div class="statistics-main--cards">
        <div class="card">
          <div class="shadow-card">
            <div class="title">Новых клиентов за период</div>
            <div class="value">{{statData.new_clients_count}}</div>
            <div v-if="isSelectedCompare" class="value-compare">
              <span class="compare-title">За период сравнения: </span>
              <span class="compare-val">{{compareStatData.new_clients_count}}</span>
            </div>
            <div class="hint"></div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="!loadedStat" class="statistics-main--no-date mrg-t-15 text-center">
      Выберите период
    </div>
  </div>
</template>

<script>
import statisticsRepository from "../../../repositories/statistics";
import Formatter from "@/components/libraries/Formatter";
const formatter = new Formatter();

export default {
  name: "StatisticsMain",
  components: {},
  data() {
    return {
      loadedStat: false,
      statData: {
        all_enroll_count: '',
        all_income: '',
        avg_check: '',
        cancel_enroll_count: '',
        done_enroll_count: '',
        fullness_percent: '',
        new_clients_count: ''
      },
      compareStatData: {
        all_enroll_count: '',
        all_income: '',
        avg_check: '',
        cancel_enroll_count: '',
        done_enroll_count: '',
        fullness_percent: '',
        new_clients_count: ''
      }
    };
  },
  props: {
    periodDateFrom: String,
    periodDateTo: String,
    periodCompareDateFrom: String,
    periodCompareDateTo: String,
    show: Boolean
  },
  watch: {
    show(val){
      if(val){
        this.checkDateAndLoad(this.periodDateFrom, this.periodDateTo, 'main');
        this.checkDateAndLoad(this.periodCompareDateFrom, this.periodCompareDateTo, 'compare');
      }
    },
    periodDateFrom: function(val){
      if(this.show){
        this.checkDateAndLoad(val, this.periodDateTo, 'main');
      }
    },
    periodDateTo: function(val){
      if(this.show){
        this.checkDateAndLoad(this.periodDateFrom, val, 'main');
      }
    },
    periodCompareDateFrom: function(val){
      if(this.show){
        this.checkDateAndLoad(val, this.periodCompareDateTo, 'compare');
      }
    },
    periodCompareDateTo: function(val){
      if(this.show){
        this.checkDateAndLoad(this.periodCompareDateFrom, val, 'compare');
      }
    },
  },
  computed: {
    isSelectedPeriod(){
      let result = false;
      if(this.periodDateFrom != '' && this.periodDateTo != ''){
        result = true;
      }
      return result;
    },
    isSelectedCompare(){
      let result = false;
      if(this.periodCompareDateFrom != '' && this.periodCompareDateTo != ''){
        result = true;
      }
      return result;
    }
  },
  methods: {
    checkDateAndLoad(dateFrom, dateTo, type){
      if(dateFrom == '' || dateTo == ''){
        return false;
      }
      let dateFromObj = formatter.rusDateToJSObject(dateFrom);
      let dateToObj = formatter.rusDateToJSObject(dateTo);

      if(dateFromObj.getTime() > dateToObj.getTime()){
        this.$store.dispatch("addNotification", {
          text: 'Дата ОТ не может быть больше даты ДО',
          time: 3,
          color: "danger"
        });
        if(type == 'main'){
          this.periodDateTo = '';
        }
        if(type == 'compare'){
          this.periodCompareDateTo = '';
        }
        return false;
      }

      if( (formatter.millisecondsToDay(dateToObj.getTime() - dateFromObj.getTime())) > 185 ){
        this.$store.dispatch("addNotification", {
          text: 'Интервал должен быть не более 6 месяцев',
          time: 3,
          color: "danger"
        });
        if(type == 'main'){
          this.periodDateTo = '';
        }
        if(type == 'compare'){
          this.periodCompareDateTo = '';
        }
        return false;
      }
      if(type == 'main'){
        this.getStatistics();
      }
      if(type == 'compare'){
        this.getCompareStatistics();
      }
    },
    getCompareStatistics(){
      this.$store.dispatch("startPreloader");

      statisticsRepository.getStat({
        type: 'main',
        dateFrom: formatter.jsObjectToPhp(formatter.rusDateToJSObject(this.periodCompareDateFrom)),
        dateTo: formatter.jsObjectToPhp(formatter.rusDateToJSObject(this.periodCompareDateTo))
      }).then(resp => {
        this.compareStatData = resp.data;
        this.$store.dispatch("stopPreloader");
      }).catch(err => {
        this.$store.dispatch("addNotification", {
          text: err.response.data.message,
          time: 6,
          color: "danger"
        });
        this.$store.dispatch("stopPreloader");
      });
    },
    getStatistics(){
      this.$store.dispatch("startPreloader");

      statisticsRepository.getStat({
        type: 'main',
        dateFrom: formatter.jsObjectToPhp(formatter.rusDateToJSObject(this.periodDateFrom)),
        dateTo: formatter.jsObjectToPhp(formatter.rusDateToJSObject(this.periodDateTo))
      }).then(resp => {
        this.loadedStat = true;
        this.statData = resp.data;
        this.$store.dispatch("stopPreloader");
      }).catch(err => {
        this.$store.dispatch("addNotification", {
          text: err.response.data.message,
          time: 6,
          color: "danger"
        });
        this.$store.dispatch("stopPreloader");
      });
    }
  },
  created() {

  }
};
</script>

<style scoped lang="less">
.statistics-main--cards{
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  flex-direction: row;
  margin-bottom: 30px;

  &>.card{
    width: 300px;
    margin-top: 5px;
    margin-right: 10px;

    .title{
      font-size: 15px;
      font-weight: 700;
    }
    .value{
      margin-top: 8px;
      font-size: 20px;
    }
    .hint{
      margin-top: 8px;
      font-size: 12px;
      color: gray;
    }
    .value-compare{
      margin-top: 10px;
      font-size: 13px;

      .compare-title{
        color: #F97979;
      }
      .compare-val{
        font-weight: 700;
      }
    }
  }
}
.statistics-main--no-date{
  color: #F97979;
}
</style>
